import store from "src/store";

export const configsSearcher = () => {
  const configs = store.getState().gamma.appConfig;
  if (configs) {
    const configFinder = (str) => {
      if (configs?.length) {
        const keyValue = configs?.find((obj) => obj.key === str);
        return keyValue?.value || false;
      }
      console.log("Log configFinder: ", str);
    };
    return { configFinder };
  }
  return { configs };
};
